<ng-container>
    <p>For security purposes your organisation needs you to set up a second method of authentication.</p>
    <br>
    <p>Plese select an option to set up authentication.</p>
</ng-container>
<form #f="ngForm">
  <div class="row text-center margin-top-base padding-top-base">
      <label>
          <input [(ngModel)]="authMethod" required type="radio" name="authMethod" value="APP" class="toggle">
          <div class="padding-top-base col-md-5 col-sm-5 "><span>APP</span></div>
      </label>
      <label>
          <input [(ngModel)]="authMethod" required type="radio" name="authMethod" value="SMS" class="toggle">
          <div class="padding-top-base col-md-5 col-sm-5 col-md-offset-1 col-sm-offset-1"><span>SMS</span></div>
      </label>
  </div>
  <div class="text-center margin-top-base padding-top-base">
      <button [disabled]="!f.form.valid" class="btn btn-primary btn-block" [ngStyle]="{'background-color': this.sharedService.ButtonColor.value, 'color':  this.sharedService.TextButtonColor.value}"
          (click)="goToChosenAuthMethod()">
          <span>CONTINUE</span>
      </button>
  </div>
</form>
